import { __ } from "@wordpress/i18n";
import { useMemo } from "@wordpress/element";
import TopicResponseSection from "./topic-response";
import ConvertSection from "./convert";
import { Tabs } from "@/components/tabs";
import { PluginRequired } from "@/components/plugin-required";
import { css } from "@/utils/css";
import { useRoute } from "@/hooks/use-route";

export default function Forumax() {
    const { navigate, query } = useRoute();

    const sections = [
        {
            value: "topic-to-post",
            label: __("Topic to Post", "antimanual"),
            title: __("Convert closed Topic to Post", "antimanual"),
            description: __("AI analyzes the closed Topics, including all replies, to create clear, well-structured posts. These posts summarize the original problem, solutions, and key insights, turning closed topics into comprehensive resources for future reference.", "antimanual"),
            element: <ConvertSection />,
        },
        {
            value: "ai-answer",
            label: __("AI Answer", "antimanual"),
            title: __("AI-Generated Answers for Forum Topics", "antimanual"),
            description: __("Enhance your forum's user experience by providing AI-generated answers to user questions based on the content of your Forum topics. This feature leverages advanced AI capabilities to deliver accurate and relevant responses, helping users find the information they need quickly and efficiently.", "antimanual"),
            element: <TopicResponseSection />,
        },
    ];

    const activeTab = useMemo(() => sections.find((s) => s.value === query.tab) || sections[0], [query.tab]);

    return (
        <PluginRequired plugin="forumax">
            <Tabs 
                standalone 
                tabs={sections} 
                activeTab={activeTab.value} 
                onTabChange={(value) => navigate(`?page=${query.page}&tab=${value}`)} 
            />
            <div className={css("pb-5 pt-2 px-2")}>
                <h2>{activeTab.title}</h2>
                <p>{activeTab.description || ""}</p>
            </div>
            <div className={css("panel")}>{activeTab.element}</div>
        </PluginRequired>
    );
}
